<lx-selector-field-container
  [label]="labelVisible ? timezoneLabel : ''"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="timezoneSelector_field"
>
  {{ selectedValue ? selectedValue?.name : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a time zone" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="timezoneSelector_sidePanel">
  <lx-timezone-selector
    [visible]="dialogVisible"
    [selectedTimezoneValue]="selectedValue"
    (selectedTimezoneChanged)="handleSelectedValue($event)"
  ></lx-timezone-selector>
</lx-side-panel>
